import {UserProvider, useUser} from "./core/context/UserContext";
import AppRouter from "./AppRouter";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIndicator from "./core/components/LoadingIndicator";
import {ModalProvider} from "./core/context/ModalContext";
import {AppProvider} from "./core/context/AppContext";
import {ConfigProvider} from "antd";
import {antdTheme} from "./core/style/antd-theme";
import {LocalStorageService} from "./core/service/local-storage-service";
import {ClipboardProvider} from "./core/contexts/ClipboardContext";
import ErrorBoundary from "./core/components/ErrorBoundary";

export default function App()
{
    return (
        <>
            {/* Küresel yükleme göstergesi. Eskiden burada her istekte açılan tam ekran karartma vardı;
                artık kısa istekler hiçbir şey göstermiyor, okuma istekleri yalnız üst çubuğu yakıyor
                (bkz. core/service/loading-indicator.js). */}
            <LoadingIndicator/>
            <div className="App">
                {/* Tema tek kaynaktan (core/style/antd-theme.js) — statik API'ler de aynısını kullanır. */}
                {/* ErrorBoundary en dışta: tek bir render hatası tüm uygulamayı beyaz ekrana düşürmesin. */}
                <ErrorBoundary>
                    <ConfigProvider theme={antdTheme}>
                        <ClipboardProvider>
                            <UserProvider>
                                <AppProvider>
                                    {/* Modal renderer'ı AppRouter'ın İÇİNDE, SignalRProvider'ın altında
                                        duruyor (bkz. AppRouter): modal içerikleri de canlı olaylara
                                        (ilerleme, bildirim) erişebilsin. Sağlayıcı burada kalırsa
                                        modal ağacı SignalR bağlamının dışında kalıyor. */}
                                    <ModalProvider>
                                        <AppRouter />
                                    </ModalProvider>
                                </AppProvider>
                            </UserProvider>
                        </ClipboardProvider>
                    </ConfigProvider>
                </ErrorBoundary>

                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </>
    )
}
